import * as React from 'react';

export default function WorkExperience() {
    return (
        <div className="detail">
            <div className="icon"><i className="fa fa-lg fa-building"></i></div>
            <div className="info">
                <h4 className="title text-uppercase">Work Experience</h4>

                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Staff Software Engineer - Reality Lab Integrity & Privacy</strong>,&nbsp;Meta </p>
                            <ul>
                                <li>Expanded ML-driven protection coverage across Meta AI and Horizon — built threat detection infrastructure for SMS verification abuse and mobile rate limiting, surfacing abuse signals to model and platform teams to harden defenses at the training stage.</li>
                                <li>Guided a team in architecting advanced threat detection infrastructure to identify and mitigate account abuse and compromise across the Meta family of apps.</li>
                                <li>Led end-to-end design of account recovery and authentication flows across Meta's family of apps, coordinating cross-functional enforcement actions and automated interventions.</li>
                                <li>Architected privacy infrastructure for data portability, account deletion, and deactivation — data residency controls and compliance-constrained architectures ensuring regional data boundaries — to meet legal compliance requirements.</li>
                                <li>Designed and led AI-driven projects leveraging MetaGen (LLM-based chatbot), including prompt engineering for support automation, adversarial input testing to surface edge cases and misuse patterns, and privacy transparency improvements across Reality Labs platforms.</li>
                                <li>Mentored engineers through career progression from Intern and SDE I/II to Senior Software Engineer.</li>
                            </ul>
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;Jul 2022</p>
                            <p><strong>Present</strong></p>
                            <p><strong>Location:</strong>&nbsp;US, Bellevue 🌲</p>
                        </div>
                    </li>
                </ul>
                
                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Software Engineer II - Anti-Abuse Team </strong>,&nbsp;Dropbox </p>
                            <ul>
                                <li>Built analyst-facing internal tooling — including an administration portal, abuse email processor, and validation service — enabling the trust & safety operations team to review and enforce against flagged content in real time.</li>
                                <li>Designed and built a restricted content service handling 50k QPS, a multi-stage malicious scanning pipeline, and telemetry and alerting infrastructure giving the trust & safety operations team real-time situational awareness over platform traffic.</li>
                                <li>Designed and built a compromise detection system for login and sign-up flows, extending coverage in collaboration with the acquisitions team.</li>
                                <li>Architected and led development of a cryptocurrency abuse scanner and malware scanning pipeline to prevent storage abuse across Dropbox products.</li>
                            </ul>
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;Feb 2021</p>
                            <p><strong>Location:</strong>&nbsp;US, Seattle 🌧️ </p>
                        </div>
                    </li>
                </ul>

                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Software Engineer II - Web Protection</strong>,&nbsp;Microsoft </p>
                            <ul>
                                <li>Designed and developed the Network Protection feature, deployed across 500M machines and blocking malicious URIs at ~6M API calls per day.</li>
                                <li>Built a multi-process web crawler and detonation service for URL threat analysis using Puppeteer.</li>
                                <li>Led cross-team optimization of the back-end job pipeline for Windows Defender and Microsoft Edge, saving $2M annually for the org and $300K within the team.</li>
                                <li>Developed delta compression, reducing bandwidth consumption by ~1TB daily.</li>
                            </ul>
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;August 2019</p>
                            <p><strong>Left:</strong>&nbsp;Feb, 2021 </p>
                            <p><strong>Location:</strong>&nbsp;US, Seattle 🌧️ </p>
                        </div>
                    </li>
                </ul>

                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Software Engineer</strong>,&nbsp;Thomson Reuters </p>
                            <ul>
                                <li>Led full-stack development of enterprise web applications using Java, React, C#, .NET, and Node.js, implementing comprehensive e2e testing with Docker, Selenium, and Cucumber</li>
                                <li>Architected and integrated RESTful Web services using Swagger, implementing automated documentation, code generation, and test-case generation</li>
                                <li>Designed and implemented high-performance search applications using Elasticsearch and MongoDB for enhanced user experience</li>
                                <li>Developed scalable, cross-platform RESTful APIs handling high-volume transactions</li>
                            </ul>
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;January, 2018</p>
                            <p><strong>Left:</strong>&nbsp;August, 2019 </p>
                            <p><strong>Location:</strong>&nbsp;Canada, Toronto ☃️ </p>
                        </div>
                    </li>
                </ul>
                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Software Engineer Intern</strong>,&nbsp;Rakuten </p>
                            <ul>
                                <li>Designed and implemented an automated data generation server and web interface, significantly streamlining the data generation process</li>
                                <li>Engineered an integrated testing system with data generation capabilities, automating testing for the internal credit card system</li>
                                <li>Developed innovative features and tools for internal products, enhancing development efficiency and workflow</li>
                            </ul>
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;May, 2017</p>
                            <p><strong>Left:</strong>&nbsp;August, 2017 </p>
                            <p><strong>Location:</strong>&nbsp;Japan, Fukuoka 🗻 </p>
                        </div>
                    </li>
                </ul>
                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Software Engineer Intern</strong>,&nbsp;Amazon </p>
                            <ul>
                                <li>Developed a REST API and interactive web tool for visualizing internal supply chain pipelines using Ruby, Angular, Java, JavaScript, and Hibernate</li>
                                <li>Implemented real-time data analysis logic for pipeline performance monitoring, enabling early detection and insights</li>
                                <li>Created an automated notification system with data analysis capabilities, providing comprehensive pipeline health monitoring and system overview</li>
                            </ul>
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;June, 2016</p>
                            <p><strong>Left:</strong>&nbsp;September, 2016 </p>
                            <p><strong>Location:</strong>&nbsp;Canada, Toronto 🌳  </p>
                        </div>
                    </li>
                </ul>
                <ul className="list-unstyled">
                    <li className="card card-nested clearfix">
                        <div className="content has-sidebar-date">
                            <p><strong>Software Engineer</strong>,&nbsp;IBM </p>
                            <ul>
                                <li>Architected and re-engineered web servers using advanced technologies:
                                    <ul>
                                        <li><b>Node.js (Sockets, Async, ES6)</b></li>
                                        <li><b>DB2, MongoDB</b></li>
                                        <li><b>Java, JavaScript, jQuery</b></li>
                                        <li><b>C for SQG Engine core</b></li>
                                    </ul>
                                </li>
                                <li>Enhanced Auto SQL Generation Engine scalability by 750x through cluster implementation</li>
                                <li>Developed a cross-platform web server integrating Java, Node.js, Cluster, DB2 & MongoDB for SQL Query Generator interaction</li>
                                <li>Created an educational Android application for DB2 certification training</li>
                                <li>Engineered <b>Performance Analysis Tool</b> and <b>Client Software Analytics Platform</b> for comprehensive data collection and analysis</li>
                                <li>
                                    Produced educational content for IBM products, including <b>YouTube tutorials</b> and internal training videos &nbsp; 
                                    <a href="https://www.youtube.com/watch?v=Q862P1ZA_Iw&index=7&list=PLdCTCL7DbgsnnYl9YLINarptciOxgF6r1">
                                        YouTube Playlist &nbsp; 
                                        <i className="menu-item-icon fa fa-fw fa-youtube-play"/>
                                    </a>
                                </li>
                            </ul>
                            <br />
                            <a href="https://github.com/IBM-DTeam">D-Team Open Source GitHub Repository</a>
                            <br />
                        </div>
                        <div className="sidebar-date text-muted text-center">
                            <p><strong>Joined:</strong>&nbsp;May, 2015</p>
                            <p><strong>Left:</strong>&nbsp;April, 2016 </p>
                            <p><strong>Location:</strong>&nbsp;Canada, Toronto 🍁 </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
}
